import Index from './modules/Index';
export const tokenURL = process.env.REACT_APP_TOKEN_URL;
export const wlpLaunchURL = process.env.REACT_APP_WLP_LAUNCH_URL;
export const httpsLaunchURL = process.env.REACT_APP_HTTPS_LAUNCH_URL;
export const apiJSONURL = process.env.REACT_APP_API_JSON_URL;
export const controllerURL = process.env.REACT_APP_CONTROLLER;
export const apiKeyURL = process.env.REACT_APP_ENCRYPT_KEY;
export const promoURL = process.env.REACT_APP_API_JSON_URL_PROMO;
export const promoURL2 = process.env.REACT_APP_API_JSON_URL_PROMO2;
export const apiUrlNew = process.env.REACT_APP_API_JSON_URL_NEW;
export const downloadAppURL = process.env.REACT_APP_DOWNLOAD;

const hostname = window.location.hostname;

const isLocalhost = hostname === 'localhost' || hostname.startsWith('192.168.');

const expectedProtocol = isLocalhost ? 'http:' : 'https:';

if (window.location.protocol !== expectedProtocol) {
    window.location.href =
        expectedProtocol +
        window.location.href.substring(window.location.protocol.length);
}

export default function App() {
    return (
        <>
            <Index />
        </>
    );
}
